import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { Box } from "./Box";
import { ColorsProvider } from "../providers/ColorsProvider";
import { useDefaultProps } from "../providers/utils/defaultProps";
import { alpha, mergeSx } from "../system";
export const progressBarClasses = {
    root: "MinervaProgressBar-root",
};
export const ProgressBar = (props) => {
    const { value = 0, color = "surface", colorSet, invertColors, sx, className, ...rest } = useDefaultProps({ props, component: "ProgressBar" });
    return (_jsx(ColorsProvider, { color: color, colorSet: colorSet, invertColors: invertColors, children: ({ background }) => {
            const trackColor = alpha(background, 0.16);
            return (_jsx(Box, { width: "100%", height: 1, className: clsx([progressBarClasses.root, className]), sx: mergeSx({
                    background: trackColor,
                    "&::after": {
                        content: '""',
                        display: "block",
                        height: "100%",
                        width: `${value ?? 0}%`,
                        background: `${background}`,
                        transition: "width 0.3s ease",
                    },
                }, sx), ...rest }));
        } }));
};
//# sourceMappingURL=ProgressBar.js.map